import React from "react";
import PropTypes from "prop-types";
import Utility from "app/horoscope/utility/utility";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function PlanetDataTable({ planetData }) {
    return (
        <div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}></th>
                        <th style={thStyleCompact}>ග්‍රහයා</th>
                        <th style={thStyleCompact}>ස්ථුටය</th>
                        <th style={thStyleCompact}>රාශිය</th>
                        <th style={thStyleCompact}>නැකත</th>
                        <th style={thStyleCompact}>රාශි බල</th>
                        <th style={thStyleCompact}>වක්‍ර</th>
                        <th style={thStyleCompact}>අවස්තාව</th>
                    </tr>
                </thead>
                <tbody>
                    {planetData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyleCompact}>{row.planet}</td>
                            <td style={tdStyleCompact}>{row.place}</td>
                            <td style={tdStyleCompact}>{row.rashiya}</td>
                            <td style={tdStyleCompact}>{row.nekatha}</td>
                            <td style={tdStyleCompact}>{row.ucha}</td>
                            <td style={tdStyleCompact}>{row.wakra}</td>
                            <td style={tdStyleCompact}>{row.awasthawa}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    PlanetDataTable.propTypes = {
        planetData: PropTypes.object.isRequired,
    };
}
